_N_E =
(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[31],{

/***/ "/RWt":
/***/ (function(module, exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/faq",
      function () {
        return __webpack_require__("vrAi");
      }
    ]);
  

/***/ }),

/***/ "1OyB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _classCallCheck; });
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}


/***/ }),

/***/ "DrxM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Accordion; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;
// デザイナー作成のjsファイルをほぼそのまま流用しているため書き方に違いがあるが、
// 現状メンテナンスは必要なし
 // FIXME dangerouslySetInnerHTMLを使用しているので使用しない様に変更する
// 現在ユーザーが入力するデータには利用していないのでXSSは発生しないが、
// ユーザー入力データを使用する場合はこのComponentを利用してはいけない

/**
 * @deprecated
 * using dangerouslySetInnerHTML
 */

var Accordion = function Accordion(_ref) {
  var id = _ref.id,
      title = _ref.title,
      content = _ref.content;

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])(''),
      setActive = _useState[0],
      setActiveState = _useState[1];

  var _useState2 = Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])('0px'),
      setHeight = _useState2[0],
      setHeightState = _useState2[1];

  var contentRef = Object(react__WEBPACK_IMPORTED_MODULE_0__["useRef"])(null);

  var toggleAccordion = function toggleAccordion() {
    var _contentRef$current;

    setActiveState(setActive === '' ? 'active' : '');
    setHeightState(setActive === 'active' ? '0px' : "".concat((_contentRef$current = contentRef.current) === null || _contentRef$current === void 0 ? void 0 : _contentRef$current.scrollHeight, "px"));
  };

  return __jsx("dl", {
    id: id,
    className: "accordion-block ".concat(setActive)
  }, __jsx("dt", {
    onClick: toggleAccordion,
    dangerouslySetInnerHTML: {
      __html: title
    }
  }), __jsx("dd", {
    ref: contentRef,
    style: {
      height: "".concat(setHeight)
    }
  }, __jsx("blockquote", {
    dangerouslySetInnerHTML: {
      __html: content
    }
  })));
};

/***/ }),

/***/ "FRS9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return USER_GUIDE_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CONTACT_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SECURITY_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return TERMS_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return POLICY_CLAUSE_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SOLICITATION_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SCT_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COMPANY_URL; });
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("mOvS");
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_0__);
 // TODO envをtestで使用できるようにconfigの設定を行う。それまではenvを使用するテストができないため、テスト対象から外す。specファイルの名前の最後に'_bk'を付与することでテストから一時的に除外する。

var _getConfig = next_config__WEBPACK_IMPORTED_MODULE_0___default()(),
    publicRuntimeConfig = _getConfig.publicRuntimeConfig;

var USER_GUIDE_URL = "".concat(publicRuntimeConfig.LWT_STATIC_DOMAIN, "/pdf/user_guide.pdf");
var CONTACT_URL = "".concat(publicRuntimeConfig.LWT_STATIC_DOMAIN, "/contact.html");
var SECURITY_URL = "".concat(publicRuntimeConfig.LWT_STATIC_DOMAIN, "/security.html");
var TERMS_URL = "".concat(publicRuntimeConfig.LWT_STATIC_DOMAIN, "/terms.html").replace('travel', 'wbf');
var POLICY_CLAUSE_URL = "".concat(publicRuntimeConfig.LWT_STATIC_DOMAIN, "/pdf/policy-clause-3286230065498525b4a9247db432bd40.pdf");
var SOLICITATION_URL = "".concat(publicRuntimeConfig.LWT_STATIC_DOMAIN, "/solicitation.html");
var SCT_URL = "".concat(publicRuntimeConfig.LWT_STATIC_DOMAIN, "/sct.html");
var COMPANY_URL = "".concat(publicRuntimeConfig.LWT_STATIC_DOMAIN, "/about/company.html");

/***/ }),

/***/ "JX7q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _assertThisInitialized; });
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}


/***/ }),

/***/ "Ji7U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _inherits; });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("s4An");

function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && Object(_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(t, e);
}


/***/ }),

/***/ "U8pU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _typeof; });
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}


/***/ }),

/***/ "bs2q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NotLoggedIn; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _components_organisms_commons_Footer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("UzZs");
/* harmony import */ var _components_organisms_commons_Header__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("AhNQ");
/* harmony import */ var _hooks_common_usePageSpecificCSS__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("VVAR");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;




var NotLoggedIn = function NotLoggedIn(_ref) {
  var children = _ref.children;

  var _usePageSpecificCSS = Object(_hooks_common_usePageSpecificCSS__WEBPACK_IMPORTED_MODULE_3__[/* usePageSpecificCSS */ "a"])('common'),
      CSSLinkTag = _usePageSpecificCSS.CSSLinkTag,
      isLoadingCSS = _usePageSpecificCSS.isLoadingCSS;

  return __jsx(react__WEBPACK_IMPORTED_MODULE_0___default.a.Fragment, null, CSSLinkTag, !isLoadingCSS && __jsx("div", null, __jsx(_components_organisms_commons_Header__WEBPACK_IMPORTED_MODULE_2__[/* Header */ "a"], null), __jsx("main", null, children, __jsx(_components_organisms_commons_Footer__WEBPACK_IMPORTED_MODULE_1__[/* Footer */ "a"], null))));
};

/***/ }),

/***/ "foSv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _getPrototypeOf; });
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}


/***/ }),

/***/ "mOvS":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("yLiY")


/***/ }),

/***/ "md7G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _possibleConstructorReturn; });
/* harmony import */ var _typeof_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("U8pU");
/* harmony import */ var _assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("JX7q");


function _possibleConstructorReturn(t, e) {
  if (e && ("object" == Object(_typeof_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return Object(_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(t);
}


/***/ }),

/***/ "o46R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ toPropertyKey; });

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__("U8pU");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPrimitive.js

function toPrimitive(t, r) {
  if ("object" != Object(esm_typeof["a" /* default */])(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != Object(esm_typeof["a" /* default */])(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPropertyKey.js


function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == Object(esm_typeof["a" /* default */])(i) ? i : i + "";
}


/***/ }),

/***/ "rePB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _defineProperty; });
/* harmony import */ var _toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("o46R");

function _defineProperty(e, r, t) {
  return (r = Object(_toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}


/***/ }),

/***/ "s4An":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _setPrototypeOf; });
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}


/***/ }),

/***/ "uPsk":
/***/ (function(module) {

module.exports = JSON.parse("[{\"group\":\"出張者\",\"contents\":[{\"title\":\"トラベルjp for Business とは？\",\"set\":[{\"id\":\"TJB1\",\"question\":\"申込の仕方がよくわかりません。\",\"answer\":\"<p>LINE WORKSからトラベルjp for Business Botを追加してください。<br>出張の日程が決まっている方は、トーク内のメニュー＞<strong>新規予約依頼</strong>から、お見積もりの依頼をお送りください。</p><p>手配内容などを相談したいという場合は、Botを追加後に、トークルームからトラベルjp for Business のコンシェルジュ（tjb_concierge@traveljpforbusiness）までご相談ください。</p><p><cite>管理者様に『外部LINE WORKS連携』を許可にご設定いただく必要があります。</cite></p>\"},{\"id\":\"TJB2\",\"question\":\"LINE WORKSを導入してない場合、利用できないのでしょうか？\",\"answer\":\"<p>ご利用いただけません。</p><p>トラベルjp for Business はLINE WORKS に付随したサービスとなっております。まずは<a href=\\\"https://line.worksmobile.com/jp/\\\" target=\\\"_blank\\\" rel=\\\"noopener noreferrer nofollow\\\">LINE WORKSの導入</a>をお願いいたします。</p><p><cite>LINE WORKS有償プランのお申込みが必要です</cite></p>\"},{\"id\":\"TJB3\",\"question\":\"コンシェルジュとは何ですか？\",\"answer\":\"<p>コンシェルジュとは皆様の出張の手配を行うスタッフのことです。お客様のご希望に合わせた交通機関や宿泊施設をご提案し、無事に出張を終えられるようにサポートいたします。</p>\"},{\"id\":\"TJB4\",\"question\":\"営業時間をおしえてください。\",\"answer\":\"<p>コンシェルジュによる手配依頼・サポート対応時間は以下となります。</p><p>平日10:00～18:00（土日・祝日除く）</p>\"},{\"id\":\"TJB5\",\"question\":\"トラベルjp for Business では何を依頼できますか？\",\"answer\":\"<p>お手配可能なものは以下となります。</p><ul><li>ホテル（国内・海外）</li><li>航空券（国内・海外）</li><li>列車（国内・海外）</li><li>Wi-Fi（海外）</li><li>レンタカー（海外）</li><li>ビザ（海外）</li></ul><p>上記に記載のないものであっても、手配可能な場合がありますので、コンシェルジュまでお気軽にご相談ください。</p>\"},{\"id\":\"TJB6\",\"question\":\"トラベルjp for Business で手配できないものはありますか？\",\"answer\":\"<p>現在お手配可能なものは、<a href=\\\"#TJB5\\\">トラベルjp for Business では何を依頼できますか？</a>をご確認ください。</p>\"},{\"id\":\"TJB7\",\"question\":\"いつまでに予約依頼をしたらいいですか？\",\"answer\":\"<p>手配依頼期限は以下の通りです。</p><ul><li>飛行機：利用日前営業日15:00まで</li><li>列車：利用日から5営業日前の17:00まで</li><li>ホテル：利用日前営業日15:00まで</li></ul><p>当日予約できるものもございます。詳しくは担当コンシェルジュへ<a href=\\\"https://lw.travel.co.jp/contact.html\\\">お問い合わせ</a>ください。</p>\"},{\"id\":\"TJB8\",\"question\":\"初期費用や月額固定費用はかかりますか？\",\"answer\":\"<p>初期費用や月額固定費用はかかりません。お見積りまでは無料でご利用いただけます。</p><p><cite>LINE WORKS有償プランのお申込みが必要です。LINE WORKSフリープランをご利用の場合は有償プランにご変更いただく必要がございます。</cite></p><p><cite>LINE WORKSのプランによってはご料金が発生する場合がございます。詳しくは<a href=\\\"https://line.worksmobile.com/jp/pricing/\\\" target=\\\"_blank\\\" rel=\\\"noopener noreferrer nofollow\\\">こちら</a></cite></p>\"},{\"id\":\"TJB9\",\"question\":\"トラベルjp for Business 利用料とは何ですか？\",\"answer\":\"<p>出張のお申込みを受けて、手配時に発生する利用料です。</p><p>利用料については<a href=\\\"/price\\\">トラベルjp for Business 利用料ページ</a>をご覧ください。</p>\"}]},{\"title\":\"トラベルjp for Business で予約する\",\"set\":[{\"id\":\"U1\",\"question\":\"利用開始の仕方がわかりません\",\"answer\":\"<p>LINE WORKSからトラベルjp for Business Botを追加してください。</p><p><img src=\\\"/img/faq/figure-u1-1.png\\\" alt=\\\"\\\"></p><p>また、Bot追加後には<strong>マイページ</strong>＞プロフィールから出張情報を更新ください。</p><p>LINE WORKS上にトラベルjp for Business Botが表示されない場合や、トラベルjp for Businessのコンシェルジュから連絡が届かない場合は、LINE WORKSの管理者様にご相談ください。</p><p><cite>コンシェルジュとの連絡のためには、管理者様に『外部LINE WORKS連携』を許可にご設定いただく必要があります。</cite></p>\"},{\"id\":\"U2\",\"question\":\"新規予約はどこからできますか？\",\"answer\":\"<p>トークルーム内のメニュー＞<strong>新規予約依頼</strong>を選択ください。</p><p>出張情報フォームを記載の上、依頼を送信ください。</p><p>また、依頼の前には<strong>マイページ</strong>＞プロフィールから出張情報を更新ください。</p>\"},{\"id\":\"U3\",\"question\":\"新規予約フォームにない項目はどうしたらいいですか？\",\"answer\":\"<p><strong>新規予約依頼</strong>ページの特記事項欄に追記ください。</p><p>不足事項につきましては、コンシェルジュより確認させていただきます。</p>\"},{\"id\":\"U4\",\"question\":\"メールで予約依頼できますか？\",\"answer\":\"<p>メールの依頼は受付ておりません。</p><p><strong>新規予約依頼</strong>ページに出張情報を記載の上、依頼を送信ください。</p>\"},{\"id\":\"U5\",\"question\":\"出張者本人ではなく、代理で予約依頼できますか？\",\"answer\":\"<p>可能です。</p><p><strong>新規予約依頼</strong>ページ内の『出張者ご本人ですか？』の質問に対して『いいえ』を選択ください。</p><p>また、特記事項欄に出張者のお名前等、予約情報を追記し、依頼を送信ください。</p>\"},{\"id\":\"U6\",\"question\":\"同行者と一緒に予約できますか？\",\"answer\":\"<p>可能です。同行者様の情報を<strong>新規予約依頼</strong>の特記事項欄に追記、依頼を送信ください。</p>\"},{\"id\":\"U7\",\"question\":\"団体旅行は予約できますか？\",\"answer\":\"<p>お見積もりにて対応をしております。</p><p>トラベルjp for Business のコンシェルジュまでご相談ください。</p>\"},{\"id\":\"U8\",\"question\":\"見積もりを依頼するだけで料金は発生しますか？\",\"answer\":\"<p>お見積もりは無料でご用意しております。</p><p>お見積もり完了後、『この内容で予約を確定する』ボタンを押したあとから、トラベルjp for Business 利用料が発生いたします。</p>\"},{\"id\":\"U9\",\"question\":\"出張費用の見積もりを書面で送付してもらえますか？\",\"answer\":\"<p>見積書をご希望の場合は個別でご用意をしております。</p><p>トラベルjp for Businessにてご用意する対象の出張トークルーム（グループトーク）からコンシェルジュまで発行希望のご連絡ください。</p>\"},{\"id\":\"U10 \",\"question\":\"予約を依頼したい場合はどうしたらいいですか？\",\"answer\":\"<p><strong>マイページ</strong>＞予約一覧＞予約詳細ページにお進みください。</p><p>予約詳細ページに表示されている『この内容で予約を確定する』のボタンを押して、手配・発券の依頼を送信ください。</p><p>手配・発券が完了しましたら、コンシェルジュより最終確認書面等をご案内させていただきます。</p>\"},{\"id\":\"U11\",\"question\":\"現地支払いの予約はできますか？\",\"answer\":\"<p>原則、現地支払いのご予約は承っておりません。</p><p>但し、基本旅程に付随するサービスなど特別手配として対応できる場合もございます。</p><p>トラベルjp for Business のコンシェルジュまでご相談ください。</p>\"},{\"id\":\"U12\",\"question\":\"旅行代金のお支払い方法を教えてください。\",\"answer\":\"<p>お見積もり完了後にコンシェルジュよりお支払い専用リンクをお送りいたします。</p><p>お支払いページでは各種クレジットカード（VISA, Master, JCB, AMEX, Diners）をご利用いただけます。</p><p>ご希望の方法を選んで、旅行代金のお支払いを完了ください。</p><p>後日一括支払いをご希望の場合は、<a href=\\\"https://lw.travel.co.jp/contact.html\\\">お問い合わせ</a>ください。</p>\"},{\"id\":\"U13\",\"question\":\"いつまでに支払いが必要ですか？\",\"answer\":\"<p>お見積もり完了後にコンシェルジュよりお支払い専用リンクをお送りいたします。</p><p>リンクお受け取り後から7日以内かつ出張出発日前営業日までにお支払いをお願いいたします。</p><p>期日内にお支払いが確認できない場合、ご予約をキャンセルさせていただく場合がございます。</p><p>ご了承ください。</p><p>また、決済期日が過ぎてしまった場合は、専用リンクを再発行させていただきます。</p><p>トラベルjp for Business のコンシェルジュまでご連絡ください。</p><p>後日一括支払いの場合は、毎月月末締めで請求書を発行いたしますので、翌月20日までにお支払いください。\"},{\"id\":\"U14\",\"question\":\"領収書はもらえますか？\",\"answer\":\"<p>領収書をご希望の場合は個別でご用意をしております。</p><p>トラベルjp for Businessにてご用意する対象の出張トークルーム（グループトーク）からコンシェルジュまで発行希望のご連絡ください。</p>\"},{\"id\":\"U15\",\"question\":\"分割払いはできますか？\",\"answer\":\"<p>分割払いは対応しておりません。</p>\"}]},{\"title\":\"変更・取消について\",\"set\":[{\"id\":\"U16\",\"question\":\"出張が中止になりました。どうしたらいいですか？\",\"answer\":\"<p>予約の取消のご対応と払い戻しが可能かコンシェルジュが確認します。</p><p>トラベルjp for Businessにてご用意する対象の出張トークルーム（グループトーク）からコンシェルジュまでご相談ください。</p>\"},{\"id\":\"U17\",\"question\":\"取消料金はいつからかかりますか？\",\"answer\":\"<p>取消料金を含む予約条件については、予約詳細ページ内で確認いただけます。</p><p><strong>マイページ</strong>＞予約一覧にお進みください。</p><p>ご確認されたい予約を選択して、予約詳細ページをお進みください。</p>\"},{\"id\":\"U18\",\"question\":\"日程や手配内容の変更はできますか？\",\"answer\":\"<p>変更可能の予約条件かをコンシェルジュが確認します。</p><p>トラベルjp for Businessにてご用意する対象の出張トークルーム（グループトーク）からコンシェルジュまで変更希望の内容をご連絡ください。</p>\"},{\"id\":\"U19\",\"question\":\"変更すると料金は発生しますか？\",\"answer\":\"<p>新しい日程によっては、変更手数料並びに追加請求が発生する場合があります。</p><p>トラベルjp for Businessにてご用意する対象の出張トークルーム（グループトーク）からコンシェルジュまでご連絡ください。</p>\"},{\"id\":\"U20\",\"question\":\"列車のチケット受領後にキャンセルになりました。どうしたらいいですか？\",\"answer\":\"<p>使用開始前までにご返却いただければ、払い戻しが可能となります。</p><p>払い戻しについては所定の手数料が発生いたします。</p><p>また、ご返却は着払いでの受付はしておりません、元払いでご郵送ください。</p><h5>返却先</h5><p>〒102-0083 東京都千代田区麹町6-6-2番町麹町ビルディング6F</p><p>株式会社ベンチャーリパブリック トラベルjp for Business 担当 宛</p>\"},{\"id\":\"U21\",\"question\":\"航空券の座席は、自分で変更できますか？\",\"answer\":\"<p>予約詳細ページ内に記載のある航空会社発行の予約番号・確認番号をご確認いただき、</p><p>各航空会社のホームページ等でお座席を自由に変更いただけます。</p><p>国際線については、オンラインチェックイン時となります。</p><p>オンラインチェックイン前に変更の希望がある場合は、コンシェルジュまでご相談ください。</p>\"}]},{\"title\":\"予約の確認について\",\"set\":[{\"id\":\"U22\",\"question\":\"滞在日程を延長できますか？\",\"answer\":\"<p>トラベルjp for Business のコンシェルジュまでご相談ください。</p><p>ホテル、航空券等の予約状況を確認して、対応可否についてご案内いたします。</p>\"},{\"id\":\"U23\",\"question\":\"予約や見積りの詳細はどこで確認できますか？\",\"answer\":\"<p><p><strong>マイページ</strong>＞予約一覧ページにお進みください。</p><p>予約リストは予約状況ごとに表示されています。</p><p>予約リストからご確認されたい予約を選択して、予約詳細ページをお進みください。</p>\"},{\"id\":\"U24\",\"question\":\"予約確認、予約完了の通知が届きません。どうしたらいいですか？\",\"answer\":\"<p>現在トラベルjp for Business は自動返信・通知は対応しておりません。</p><p>また、トラベルjp for Business の営業時間は平日10:00~18:00となっており、営業時間外はメッセージの送付は停止しております。</p><p>コンシェルジュからご予約依頼が確認でき次第、順次ご返答をさせていただきます。</p><p>お急ぎのご依頼の場合など、電話やメールでも<a href=\\\"https://lw.travel.co.jp/contact.html\\\">お問い合わせ</a>を承っております。</p>\"},{\"id\":\"U25\",\"question\":\"過去の予約を確認できますか？\",\"answer\":\"<p><p><strong>マイページ</strong>＞予約一覧ページにお進みください。</p><p>予約リストは予約状況ごとに表示されています。</p><p>『手配済み』のリストに過去の予約が表示されています。</p>\"},{\"id\":\"U26\",\"question\":\"見積り依頼が、リストにありません。どうしたらいいですか？\",\"answer\":\"<p><p><strong>マイページ</strong>＞予約一覧ページにお進みください。</p><p>予約リストの『見積中』に依頼した予約がないかご確認ください。</p><p>予約がない場合は、新規手配依頼が送信完了していない可能性があります。</p><p><p><strong>マイページ</strong>より『新規手配依頼』ページから再度予約内容を登録し、送信完了ください。</p>\"},{\"id\":\"U27\",\"question\":\"航空券のマイレージの事前登録はできますか？\",\"answer\":\"<p>コンシェルジュに発券依頼時にマイレージ番号と発行航空会社をご連絡ください。</p><p>プロフィールにマイレージ情報をご登録いただいている場合は、</p><p>発券ごとのご連絡は不要です。</p><p>プロフィールは<p><strong>マイページ</strong>からご確認ください。</p>\"},{\"id\":\"U28\",\"question\":\"航空券の受取方法を教えてください。\",\"answer\":\"<p>航空券は、発券後に専用のURLリンクからご案内いたします。</p><p>専用URLリンクにアクセスいただき、事前に航空券をダウンロードください。</p>\"},{\"id\":\"U29\",\"question\":\"新幹線・特急列車チケットの受取方法を教えてください。\",\"answer\":\"<p>新幹線・特急列車チケットは、ご自身にて駅で発券可能なチケット引き換えQRコードをご案内致します。</p><p>QR発券が出来ない一部のエリアは、弊社にて発券後、チケット原本を郵送でご案内を致します。</p><p>希望の送付先をコンシェルジュまでご連絡ください。</p>\"},{\"id\":\"U30\",\"question\":\"ファイルがダウンロードできません。どうしたらいいですか？\",\"answer\":\"<p>確認書面の受渡用のURLリンクをご確認をお願いいたします。</p><p>アクセスにはパスワードが設定されています。</p><p>パスワードはトラベルjp for Businessのコンシェルジュよりご案内いたします。</p><p>アクセスができない場合は、コンシェルジュにご相談ください。</p>\"}]},{\"title\":\"トークについて\",\"set\":[{\"id\":\"U31\",\"question\":\"トラベルjp for Businessのトークルームが複数ありますが、何が違いますか？\",\"answer\":\"<p>トラベルjp for Businessのbotによるトークルームは配信専用となります。</p><p>コンシェルジュが、各ご出張ごとにご用意するトークルームは、出張に関する個別のやり取りが可能です。</p>\"},{\"id\":\"U32\",\"question\":\"同行者、出張者を招待したいです。どうしたらいいですか？\",\"answer\":\"<p>トラベルjp for Businessにてご用意する対象の出張トークルーム（グループトーク）からコンシェルジュまでご相談ください。</p>\"},{\"id\":\"U33\",\"question\":\"画像ファイルやPDFは送れますか？\",\"answer\":\"<p>トラベルjp for Businessにてご用意する対象の出張トークルーム（グループトーク）では、画像ファイルやPDFの添付が可能です。</p><p>添付ファイルの仕様については、<a href=\\\"https://help.worksmobile.com/jp/message/send-file/limit-file-size-to-send-in-message/\\\" target=\\\"_blank\\\" rel=\\\"noopener noreferrer nofollow\\\">こちら</a>をご確認ください。</p>\"}]},{\"title\":\"旅行代金とトラベルjp for Business 利用料について\",\"set\":[{\"id\":\"TJB10\",\"question\":\"トラベルjp for Business 利用料はいくらかかりますか？\",\"answer\":\"<p>トラベルjp for Business 利用料は、手配内容によって異なります。</p><p>手配済みの場合は、<p><strong>マイページ</strong>より旅程詳細からご請求予定の利用料をご確認いただけます。</p><p>利用料の詳細は<a href=\\\"/price\\\">こちら</a>をご確認ください。</p>\"},{\"id\":\"TJB11\",\"question\":\"トラベルjp for Business 利用料は出張者単位になりますか？\",\"answer\":\"<p>トラベルjp for Business 利用料は、出張者単位で請求致します。</p><p>利用料の詳細は<a href=\\\"/price\\\">こちら</a>をご確認ください。</p>\"},{\"id\":\"TJB12\",\"question\":\"トラベルjp for Business 利用料はどのように請求されますか？\",\"answer\":\"<p>LINE WORKSを販売代理店経由でご契約の場合は、販売代理店によりトラベルjp for Business 利用料の請求方法が異なりますので、販売代理店までお問い合わせください。</p><p>LINE WORKSを直接契約している場合は、トラベルjp for Business 利用料は旅行代金と合わせて請求させていただきます。</p>\"},{\"id\":\"TJB13\",\"question\":\"出張旅行代金はどのように請求されますか？\",\"answer\":\"<p>出張旅行代金は、事前にクレジットカードにてお支払いをいただきます。</p><p>お見積もり完了後に、担当コンシェルジュから専用のURLリンクをご案内いたします。</p><p>URLリンクから決済ページにアクセスいただき、お支払い手続きを完了ください。</p><p>後日一括支払いのご契約企業様は、契約書に記載さいれた期日までに運営会社より</p><p>旅行代金の明細リスト並びにご請求書をご案内申し上げます。</p>\"},{\"id\":\"TJB14\",\"question\":\"出張旅行代金を後日一括でお支払いすることはできますか？\",\"answer\":\"<p>後日一括支払いをご希望の場合は、<a href=\\\"https://lw.travel.co.jp/contact.html\\\">お問い合わせ</a>ください。</p><p>変更に際しては、運営会社ベンチャーリパブリック社の与信審査等の手続きが必要となります。</p><p>手続き完了までは、旅行費用はクレジットカードにて決済のみとなります。</p>\"}]},{\"title\":\"サイト不具合（エラー）\",\"set\":[{\"id\":\"TJB15\",\"question\":\"利用開始しましたが、返信がありません。どうしたらいいですか？\",\"answer\":\"<p>現在トラベルjp for Business のコンシェルジュによる応答は自動返信・通知に対応しておりません。</p><p>ご依頼、ご質問、ご相談等は、営業時間（平日10:00~18:00）内に順次確認後、ご連絡いたします。</p><p>なお、コンシェルジュからのご連絡は新規のお見積もり依頼をいただいてからとなります。</p><p>トークルーム内のメニューから『新規出張手配』をお選びいただき、お見積もりの送信をお願いいたします。</p><p>お急ぎのご依頼の場合など、電話やメールでもお問い合わせを承っております。</p>\"},{\"id\":\"TJB16\",\"question\":\"新規見積を依頼しましたが、返信がありません。どうしたらいいですか？\",\"answer\":\"<p>現在トラベルjp for Business のコンシェルジュによる応答は自動返信・通知に対応しておりません。</p><p>お見積りに関するご返信は、営業時間（平日10:00~18:00）内にお見積もりのご準備でき次第、ご連絡いたします。</p><p>お急ぎのご依頼の場合など、電話やメールでもお問い合わせを承っております。</p>\"},{\"id\":\"TJB17\",\"question\":\"航空券が届きません。どうしたらいいですか？\",\"answer\":\"<p><p><strong>マイページ</strong>をご確認いただき、『この内容で手配を確定する』ボタンを押して手配・発券の依頼をお願いいたします。</p><p>発券のご依頼をいただいている場合は、コンシェルジュが航空券等の確認書面をご準備しております。</p><p>ご準備ができましたら、確認書面の受渡用のURLリンクをご案内させていただきます。</p><p>URLリンクが届いていないか、トークルームをご確認をお願いいたします。</p><p>URLリンクが届いていない場合は、トラベルjp for Businessにてご用意する対象の出張トークルーム（グループトーク）からコンシェルジュまでご相談ください。</p>\"},{\"id\":\"TJB18\",\"question\":\"画像を送付したのですが、反応がありません。どうしたらいいですか？\",\"answer\":\"<p>画像のファイル1件あたりのサイズが上限を超えている可能性があります。<p><p>ファイルのサイズをご確認の上、ご再送ください。<p><p>添付ファイルの仕様については、<a href=\\\"https://help.worksmobile.com/jp/message/send-file/limit-file-size-to-send-in-message/\\\" target=\\\"_blank\\\" rel=\\\"noopener noreferrer nofollow\\\">こちら</a>をご確認ください。</p>\"}]},{\"title\":\"その他お問い合わせ\",\"set\":[{\"id\":\"TJB19\",\"question\":\"予約した便が欠航となりました。どうしたらいいですか？\",\"answer\":\"<p>欠航が確定している場合は、各航空会社へにご連絡いただき、お振替又は、キャンセルのお手続きをお願いいたします。</p><p>航空会社へ連絡がとれない、振替に時間がかかっているなどお困りの場合は、トラベルjp for Businessにてご用意する対象の出張トークルーム（グループトーク）からコンシェルジュまでご相談下さい。</p><p>また、欠航が確定していない場合は、航空会社の運航の決定をお待ちいただけますようお願いいたします。</p>\"},{\"id\":\"TJB20\",\"question\":\"予約した便に間に合いません。どうしたらいいですか？\",\"answer\":\"<p>航空会社により対応が異なります。</p><p>まずは予約している航空会社までご連絡し、対応方法の確認をお願いいたします。</p><p>キャンセル処理を行った場合は、トラベルjp for Businessにてご用意する対象の出張トークルーム（グループトーク）からコンシェルジュまでご連絡ください。</p><p>また、交通機関の遅延により予約便に乗り遅れとなる場合は、運休・遅延証明書を取得のうえ、空港の航空会社カウンターで振替又は、キャンセルのお手続きをお願いいたします。</p>\"},{\"id\":\"TJB21\",\"question\":\"予約をしたホテルと違うホテルに誘導されました。どうしたらいいですか？\",\"answer\":\"<p>まずは予約元の緊急連絡先までご連絡をいただき、違うホテルに誘導された旨をご連絡ください。</p><p>緊急連絡先は、ご予約完了時にお渡しする予約確認書面（バウチャー）に記載されています。</p><p>見当たらない場合は、トラベルjp for Businessにてご用意する対象の出張トークルーム（グループトーク）からコンシェルジュまでご連絡ください。</p><p>また、移動先のホテルや客室にご満足いただけない場合や提供サービスが同等ではない場合は、予約元を通してホテルやお部屋の変更の交渉を対応いたします。</p><p>コンシェルジュまでご満足いただけない理由などを添えてご相談ください。</p>\"},{\"id\":\"TJB22\",\"question\":\"列車のチケットを紛失しました。どうしたらいいですか？\",\"answer\":\"<p>列車のチケット原本を紛失された場合は、いかなる場合でも再発行はいたしません。</p><p>新たにご乗車に必要な乗車券・特急券等を再度お買い求めください。</p><p>また、紛失再発行における払戻しの対応が可能となる場合があります。駅係員まで紛失再発行の証明の取得とお手続きのご確認をお願いいたします。お手続きについては<a href=\\\"https://www.jreast.co.jp/ryokaku/02_hen/07_syo/03_setsu/04.html#268\\\" target=\\\"_blank\\\" rel=\\\"noopener noreferrer nofollow\\\">こちら</a>をご確認ください。</p>\"},{\"id\":\"TJB27\",\"question\":\"出張や旅行が終わった後でも、相談できますか？\",\"answer\":\"<p>可能です。トラベルjp for Business と手配のやり取りをしたトークルームにご相談内容をそのままご連絡ください。</p><p>ご連絡の際は、ご予約番号やご予約内容が確認できる旅行先、旅行期間、宿泊施設の情報を追記ください。</p>\"},{\"id\":\"TJB28\",\"question\":\"電話で直接話したいです。どうしたらいいですか？\",\"answer\":\"<p>緊急のご連絡や通信環境に問題がある場合は、お電話でも対応を承っております。<br>営業時間をご確認の上、ご連絡ください。</p><p>050-3131-7631</p><ul class=\\\"no-list\\\"><li><cite>営業時間：10:00-18:00</cite></li><li><cite>通話料金は原則発信者負担となります。ご了承ください。</cite></li></ul>\"}]}]},{\"group\":\"管理者\",\"contents\":[{\"title\":\"トラベルjp for Business とは？\",\"set\":[{\"id\":\"TJB1\",\"question\":\"申込の仕方がよくわかりません。\",\"answer\":\"<p>LINE WORKSからトラベルjp for Business Botを追加してください。<br>出張の日程が決まっている方は、トーク内のメニュー＞<strong>新規予約依頼</strong>から、お見積もりの依頼をお送りください。</p><p>手配内容などを相談したいという場合は、Botを追加後に、トラベルjp for Business のコンシェルジュ（tjb_concierge@traveljpforbusiness）までご相談ください。</p><p><cite>管理者様に『外部LINE WORKS連携』を許可にご設定いただく必要があります。</cite></p>\"},{\"id\":\"TJB2\",\"question\":\"LINE WORKSを導入してない場合、利用できないのでしょうか？\",\"answer\":\"<p>ご利用いただけません。</p><p>トラベルjp for Business はLINE WORKS に付随したサービスとなっております。まずは<a href=\\\"https://line.worksmobile.com/jp/\\\" target=\\\"_blank\\\" rel=\\\"noopener noreferrer nofollow\\\">LINE WORKSの導入</a>をお願いいたします。無料プランでもトラベルjp for Business のご利用は可能です。</p>\"},{\"id\":\"TJB3\",\"question\":\"コンシェルジュとは何ですか？\",\"answer\":\"<p>コンシェルジュとは皆様の出張の手配を行うスタッフのことです。お客様のご希望に合わせた交通機関や宿泊施設をご提案し、無事に出張を終えられるようにサポートいたします。</p>\"},{\"id\":\"TJB4\",\"question\":\"営業時間をおしえてください。\",\"answer\":\"<p>コンシェルジュによる手配依頼・サポート対応時間は以下となります。</p><p>平日10:00～18:00（土日・祝日除く）</p>\"},{\"id\":\"TJB5\",\"question\":\"トラベルjp for Business では何を依頼できますか？\",\"answer\":\"<p>お手配可能なものは以下となります。</p><ul><li>ホテル（国内・海外）</li><li>航空券（国内・海外）</li><li>列車（国内・海外）</li><li>Wi-Fi（海外）</li><li>レンタカー（海外）</li><li>ビザ（海外）</li></ul>\"},{\"id\":\"TJB6\",\"question\":\"トラベルjp for Business で手配できないものはありますか？\",\"answer\":\"<p>現在お手配可能なものは、<a href=\\\"#TJB5\\\">トラベルjp for Business では何を依頼できますか？</a>をご確認ください。</p>\"},{\"id\":\"TJB7\",\"question\":\"いつまでに予約依頼をしたらいいですか？\",\"answer\":\"<p>手配依頼期限は以下となります。</p><ul><li>飛行機：利用日前営業日15:00まで</li><li>列車：利用日から5営業日前の17:00まで</li><li>ホテル：利用日前営業日15:00まで</li></ul><p>当日予約できるものもございます。詳しくは担当コンシェルジュへお問い合わせください。</p>\"},{\"id\":\"TJB8\",\"question\":\"初期費用や月額固定費用はかかりますか？\",\"answer\":\"<p>初期費用や月額固定費用はかかりません。お見積りまでは無料でご利用いただけます。</p><p><cite>LINE WORKSのプランによってはご料金が発生する場合がございます。詳しくは<a href=\\\"https://line.worksmobile.com/jp/pricing/\\\" target=\\\"_blank\\\" rel=\\\"noopener noreferrer nofollow\\\">こちら</a></cite></p>\"},{\"id\":\"TJB9\",\"question\":\"トラベルjp for Business 利用料とは何ですか？\",\"answer\":\"<p>出張のお申込みを受けて、手配時に発生する利用料です。</p><p>トラベルjp for Business 利用料については<a href=\\\"/price\\\">トラベルjp for Business 利用料ページ</a>をご覧ください。</p>\"}]},{\"title\":\"トラベルjp for Business を利用する\",\"set\":[{\"id\":\"A5\",\"question\":\"社員のプロフィール情報を編集できますか？\",\"answer\":\"<p><strong>マイページ</strong>＞メンバー一覧から登録されたプロフィールの閲覧のみ可能です。</p><p>編集権限はメンバーのみとなり、管理者は編集できません。</p>\"},{\"id\":\"A6\",\"question\":\"社外ゲストの手配をお願いしたいです。\",\"answer\":\"<p>代理申請が可能です。</p><p>出張依頼フォームの特記事項欄に社外ゲスト手配の旨ご記入いただけましたらコンシェルジュが対応させていただきます。</p><p>お支払いフローなどもトラベルjp for Businessにてご用意する対象の出張トークルーム（グループトーク）にて確認させていただきます。</p><p><cite>社外ゲストの場合は手配完了通知は出張者ご本人には届きませんので予めご了承ください。</cite></p>\"},{\"id\":\"A7\",\"question\":\"代理手配の場合、出張者本人に手配完了通知はとどきますか？\",\"answer\":\"<p>代理手配の場合、出張者ご本人様には手配完了通知は届きません。予めご了承ください。</p>\"},{\"id\":\"A8\",\"question\":\"代理手配でも、出張者本人にチケット類を送ってほしいです。\",\"answer\":\"<p>可能です。</p><p>手配完了後、担当コンシェルジュに送付先をお知らせください。</p>\"},{\"id\":\"A9\",\"question\":\"資料がほしいです。どこから確認できますか？\",\"answer\":\"<p>LINE WORKSを販売代理店経由でご契約の場合は、販売代理店までお問合わせください。</p><p>LINE WORKSを直接契約している場合は、<a href=\\\"https://lw.travel.co.jp/contact.html\\\">お問い合わせ</a>ページからご連絡ください。</p>\"},{\"id\":\"A11\",\"question\":\"未払いの利用料、旅行代金がありますが、先に退会手続きできますか？\",\"answer\":\"<p>旅行代金の精算が完了しない場合、退会のお手続きは対応できません。</p><p>最後の予約を確認し、決済完了後に退会手続きをお願いいたします。</p>\"},{\"id\":\"A12\",\"question\":\"退会後に返金が発生しました。どうしたらいいですか？\",\"answer\":\"<p>返金は決済いただいたクレジットカードにご返金致します。<br>退会後でも対応は可能です。</p><p>返金が発生した理由等を<a href=\\\"https://lw.travel.co.jp/contact.html\\\">お問い合わせ</a>ページからご連絡ください。</p><p>後日一括支払いのご契約企業様は、銀行振込にて返金いたします。</p>\"},{\"id\":\"A13\",\"question\":\"退会後のデータはどうなりますか？\",\"answer\":\"<p>ご契約中に作成されたデータは解約お手続き後、閲覧不可となります。</p><p>セキュリティ上、データの運用ガイドラインは非公開となります。ご了承ください。</p>\"}]},{\"title\":\"予約の確認について\",\"set\":[{\"id\":\"A14\",\"question\":\"トラベルjp for Business を利用している社員を確認したいです。\",\"answer\":\"<p><strong>マイページ</strong>＞メンバー一覧 からご確認いただけます。</p>\"},{\"id\":\"A15\",\"question\":\"予約状況を確認したいです。どこからできますか？\",\"answer\":\"<p><strong>マイページ</strong>＞予約一覧 又は、リッチメニューの予約確認からご確認いただけます。</p>\"},{\"id\":\"A16\",\"question\":\"予約レポートを取得したいです。\",\"answer\":\"<p>予約レポートの抽出機能はございません。<br>追加機能として将来的に追加される予定です。</p><p>予約リストをご希望の場合は、コンシェルジュが抽出、ご提供いたします。トラベルjp for Businessにてご用意する対象の出張トークルーム（グループトーク）内でご相談ください。</p>\"},{\"id\":\"A17\",\"question\":\"トラベルjp for Business 利用料はどこで確認できますか？\",\"answer\":\"<p><strong>マイページ</strong>＞予約一覧から確認したい予約を選択ください。</p><p>予約詳細画面内に請求が発生している利用料が確認いただけます。</p>\"},{\"id\":\"A18\",\"question\":\"旅行代金はどこで確認できますか？\",\"answer\":\"<p><strong>マイページ</strong>＞予約一覧から旅行代金（出張費用）を確認したい予約を選択ください。</p><p>予約リストは予約状況ごとに表示されています。</p>\"}]},{\"title\":\"旅行代金と手配手数料について\",\"set\":[{\"id\":\"TJB10\",\"question\":\"トラベルjp for Business 利用料はいくらかかりますか？\",\"answer\":\"<p>トラベルjp for Business 利用料は、手配内容によって異なります。</p><p>手配済みの場合は、<p><strong>マイページ</strong>より旅程詳細からご請求予定の利用料をご確認いただけます。</p><p>利用料の詳細は<a href=\\\"/price\\\">こちら</a>をご確認ください。</p>\"},{\"id\":\"TJB11\",\"question\":\"トラベルjp for Business 利用料は出張者単位になりますか？\",\"answer\":\"<p>トラベルjp for Business 利用料は、出張者単位でご請求致します。</p><p>利用料の詳細は<a href=\\\"/price\\\">こちら</a>をご確認ください。</p>\"},{\"id\":\"TJB12\",\"question\":\"トラベルjp for Business 利用料はどのように請求されますか？\",\"answer\":\"<p>LINE WORKSを販売代理店経由でご契約の場合は、販売代理店によりトラベルjp for Business 利用料の請求方法が異なりますので、販売代理店までお問い合わせください。</p><p>LINE WORKSを直接契約している場合は、トラベルjp for Business 利用料は旅行代金と合わせて請求させていただきます。</p>\"},{\"id\":\"TJB13\",\"question\":\"出張旅行代金はどのように請求されますか？\",\"answer\":\"<p>出張旅行代金は、事前にクレジットカードにてお支払いをいただきます。</p><p>お見積もり完了後に、担当コンシェルジュから専用のURLリンクをご案内いたします。</p><p>URLリンクから決済ページにアクセスいただき、お支払い手続きを完了ください。</p><p>後日一括支払いのご契約企業様は、契約書に記載さいれた期日までに運営会社より</p><p>旅行代金の明細リスト並びにご請求書をご案内申し上げます。</p>\"},{\"id\":\"TJB14\",\"question\":\"出張旅行代金を後日一括でお支払いすることはできますか？\",\"answer\":\"<p>後日一括支払いをご希望の場合は、<a href=\\\"https://lw.travel.co.jp/contact.html\\\">お問い合わせ</a>ください。</p><p>変更に際しては、運営会社ベンチャーリパブリック社の与信審査等の手続きが必要となります。</p><p>手続き完了までは、旅行費用はクレジットカードにて決済のみとなります。</p>\"}]},{\"title\":\"サイト不具合（エラー）\",\"set\":[{\"id\":\"TJB15\",\"question\":\"利用開始しましたが、返信がありません。どうしたらいいですか？\",\"answer\":\"<p>現在トラベルjp for Business のコンシェルジュによる応答は自動返信・通知に対応しておりません。</p><p>ご依頼、ご質問、ご相談等は、営業時間（平日10:00~18:00）内に順次確認後、ご連絡いたします。</p><p>なお、コンシェルジュからのご連絡は新規のお見積もり依頼をいただいてからとなります。</p><p>トークルーム内のメニューから『新規出張手配』をお選びいただき、お見積もりの送信をお願いいたします。</p><p>お急ぎのご依頼の場合など、電話やメールでも<a href=\\\"https://lw.travel.co.jp/contact.html\\\">お問い合わせ</a>を承っております。</p>\"},{\"id\":\"TJB16\",\"question\":\"新規見積を依頼しましたが、返信がありません。どうしたらいいですか？\",\"answer\":\"<p>現在トラベルjp for Business のコンシェルジュによる応答は自動返信・通知に対応しておりません。</p><p>お見積りに関するご返信は、営業時間（平日10:00~18:00）内にお見積もりのご準備でき次第、ご連絡いたします。</p><p>お急ぎのご依頼の場合など、電話やメールでも<a href=\\\"https://lw.travel.co.jp/contact.html\\\">お問い合わせ</a>を承っております。</p>\"},{\"id\":\"TJB17\",\"question\":\"航空券が届きません。どうしたらいいですか？\",\"answer\":\"<p><p><strong>マイページ</strong>をご確認いただき、『この内容で手配を確定する』ボタンを押して手配・発券の依頼をお願いいたします。</p><p>発券のご依頼をいただいている場合は、コンシェルジュが航空券等の確認書面をご準備しております。</p><p>ご準備ができましたら、確認書面の受渡用のURLリンクをご案内させていただきます。</p><p>URLリンクが届いていないか、トークルームをご確認をお願いいたします。</p><p>URLリンクが届いていない場合は、トラベルjp for Businessにてご用意する対象の出張トークルーム（グループトーク）からコンシェルジュまでご相談ください。</p>\"},{\"id\":\"TJB18\",\"question\":\"画像を送付したのですが、反応がありません。どうしたらいいですか？\",\"answer\":\"<p>画像のファイル1件あたりのサイズが上限を超えている可能性があります。</p><p>ファイルのサイズをご確認の上、ご再送ください。</p><p>添付ファイルの仕様については、<a href=\\\"https://help.worksmobile.com/jp/message/send-file/limit-file-size-to-send-in-message/\\\" target=\\\"_blank\\\" rel=\\\"noopener noreferrer nofollow\\\">こちら</a>をご確認ください。</p>\"}]},{\"title\":\"その他お問い合わせ\",\"set\":[{\"id\":\"TJB19\",\"question\":\"予約した便が欠航となりました。どうしたらいいですか？\",\"answer\":\"<p>欠航が確定している場合は、各航空会社へにご連絡いただき、お振替又は、キャンセルのお手続きをお願いいたします。</p><p>航空会社へ連絡がとれない、振替に時間がかかっているなどお困りの場合は、トラベルjp for Businessにてご用意する対象の出張トークルーム（グループトーク）からコンシェルジュまでご相談下さい。</p><p>また、欠航が確定していない場合は、航空会社の運航の決定をお待ちいただけますようお願いいたします。</p>\"},{\"id\":\"TJB20\",\"question\":\"予約した便に間に合いません。どうしたらいいですか？\",\"answer\":\"<p>航空会社により対応が異なります。</p><p>まずは予約している航空会社までご連絡し、対応方法の確認をお願いいたします。</p><p>キャンセル処理を行った場合は、トラベルjp for Businessにてご用意する対象の出張トークルーム（グループトーク）からコンシェルジュまでご連絡ください。</p><p>また、交通機関の遅延により予約便に乗り遅れとなる場合は、運休・遅延証明書を取得のうえ、空港の航空会社カウンターで振替又は、キャンセルのお手続きをお願いいたします。</p>\"},{\"id\":\"TJB21\",\"question\":\"予約をしたホテルと違うホテルに誘導されました。どうしたらいいですか？\",\"answer\":\"<p>まずは予約元の緊急連絡先までご連絡をいただき、違うホテルに誘導された旨をご連絡ください。</p><p>緊急連絡先は、ご予約完了時にお渡しする予約確認書面（バウチャー）に記載されています。</p><p>見当たらない場合は、トラベルjp for Businessにてご用意する対象の出張トークルーム（グループトーク）からコンシェルジュまでご連絡ください。</p><p>また、移動先のホテルや客室にご満足いただけない場合や提供サービスが同等ではない場合は、予約元を通してホテルやお部屋の変更の交渉を対応いたします。</p><p>コンシェルジュまでご満足いただけない理由などを添えてご相談ください。</p>\"},{\"id\":\"TJB22\",\"question\":\"列車のチケットを紛失しました。どうしたらいいですか？\",\"answer\":\"<p>列車のチケット原本を紛失された場合は、いかなる場合でも再発行はいたしません。</p><p>新たにご乗車に必要な乗車券・特急券等を再度お買い求めください。</p><p>また、紛失再発行における払戻しの対応が可能となる場合があります。駅係員まで紛失再発行の証明の取得とお手続きのご確認をお願いいたします。お手続きについては<a href=\\\"https://www.jreast.co.jp/ryokaku/02_hen/07_syo/03_setsu/04.html#268\\\" target=\\\"_blank\\\" rel=\\\"noopener noreferrer nofollow\\\">こちら</a>をご確認ください。</p>\"},{\"id\":\"TJB27\",\"question\":\"出張や旅行が終わった後でも、相談できますか？\",\"answer\":\"<p>可能です。トラベルjp for Business と手配のやり取りをしたトークルームにご相談内容をそのままご連絡ください。</p><p>ご連絡の際は、ご予約番号やご予約内容が確認できる旅行先、旅行期間、宿泊施設の情報を追記ください。</p>\"},{\"id\":\"TJB28\",\"question\":\"電話で直接話したいです。どうしたらいいですか？\",\"answer\":\"<p>緊急のご連絡や通信環境に問題がある場合は、お電話でも対応を承っております。<br>営業時間をご確認の上、ご連絡ください。</p><p>050-3131-7631</p><ul class=\\\"no-list\\\"><li><cite>営業時間：10:00-18:00</cite></li><li><cite>通話料金は原則発信者負担となります。ご了承ください。</cite></li></ul>\"}]}]}]");

/***/ }),

/***/ "vrAi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "Faq", function() { return /* binding */ faq_Faq; });

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__("g4pe");
var head_default = /*#__PURE__*/__webpack_require__.n(head);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// CONCATENATED MODULE: ./src/components/pages/faq/common.tsx
var __jsx = react_default.a.createElement;
// デザイナー作成のjsファイルをほぼそのまま流用しているため書き方に違いがあるが、
// 現状メンテナンスは必要なし

var BigButton = function BigButton(_ref) {
  var title = _ref.title,
      link = _ref.link;
  return __jsx("a", {
    href: link,
    className: "button-large"
  }, title);
};
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("1OyB");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("vuIU");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("Ji7U");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("md7G");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("foSv");

// EXTERNAL MODULE: ./src/components/atoms/Accordion.tsx
var Accordion = __webpack_require__("DrxM");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("JX7q");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("rePB");

// CONCATENATED MODULE: ./src/components/pages/faq/tab.tsx
var tab_jsx = react_default.a.createElement;
// デザイナー作成のjsファイルをほぼそのまま流用しているため書き方に違いがあるが、
// 現状メンテナンスは必要なし

var Tab = function Tab(_ref) {
  var label = _ref.label,
      activeTab = _ref.activeTab,
      _onClick = _ref.onClick;
  var className = '';

  if (activeTab === label) {
    className += ' active';
  }

  return tab_jsx("div", {
    className: className,
    onClick: function onClick() {
      return _onClick(label);
    }
  }, label);
};
// CONCATENATED MODULE: ./src/components/pages/faq/tabs.jsx







var tabs_jsx = react_default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

// デザイナー作成のjsファイルをほぼそのまま流用しており、
// そのままtsxファイルに変換すると警告が出るため、jsxファイルとして保存した。



var tabs_Tabs = /*#__PURE__*/function (_React$Component) {
  Object(inherits["a" /* default */])(Tabs, _React$Component);

  var _super = _createSuper(Tabs);

  function Tabs(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, Tabs);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onClickTabItem", function (tab) {
      _this.setState({
        activeTab: tab
      });
    });

    _this.state = {
      activeTab: _this.props.children[0].props.label
    };
    return _this;
  }

  Object(createClass["a" /* default */])(Tabs, [{
    key: "render",
    value: function render() {
      var onClickTabItem = this.onClickTabItem,
          _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          activeTab = this.state.activeTab;
      return tabs_jsx("div", {
        className: "tab-block ".concat(className)
      }, tabs_jsx("div", {
        className: "tab-block-buttons"
      }, children.map(function (child) {
        var label = child.props.label;
        return tabs_jsx(Tab, {
          activeTab: activeTab,
          key: label,
          label: label,
          onClick: onClickTabItem
        });
      })), tabs_jsx("div", {
        className: "tab-block-content"
      }, children.map(function (child) {
        if (child.props.label !== activeTab) return undefined;
        return child.props.children;
      })));
    }
  }]);

  return Tabs;
}(react_default.a.Component);

Object(defineProperty["a" /* default */])(tabs_Tabs, "defaultProps", {
  className: ''
});

/* harmony default export */ var tabs = (tabs_Tabs);
// CONCATENATED MODULE: ./src/components/pages/faq/faq-tabs.jsx





var faq_tabs_jsx = react_default.a.createElement;

function faq_tabs_createSuper(Derived) { var hasNativeReflectConstruct = faq_tabs_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function faq_tabs_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

// デザイナー作成のjsファイルをほぼそのまま流用しており、
// そのままtsxファイルに変換すると警告が出るため、jsxファイルとして保存した。




var faq_tabs_FaqTabs = /*#__PURE__*/function (_React$Component) {
  Object(inherits["a" /* default */])(FaqTabs, _React$Component);

  var _super = faq_tabs_createSuper(FaqTabs);

  function FaqTabs(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, FaqTabs);

    _this = _super.call(this, props);
    _this.state = {
      items: undefined
    };
    return _this;
  }

  Object(createClass["a" /* default */])(FaqTabs, [{
    key: "render",
    value: function render() {
      return faq_tabs_jsx(tabs, {
        className: "faq-block"
      }, this.state.items);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if (state.items === undefined) {
        return {
          items: props.items.map(function (eachData) {
            return faq_tabs_jsx("div", {
              key: eachData.group,
              label: eachData.group
            }, eachData.contents.map(function (eachContents) {
              return faq_tabs_jsx(react_default.a.Fragment, {
                key: eachContents.title
              }, faq_tabs_jsx("h3", null, eachContents.title), eachContents.set.map(function (eachQuestion, k) {
                return faq_tabs_jsx(Accordion["a" /* Accordion */], {
                  key: k,
                  id: eachQuestion.id,
                  title: '<h4>' + eachQuestion.question + '</h4>',
                  content: eachQuestion.answer
                });
              }));
            }));
          })
        };
      }

      return null;
    }
  }]);

  return FaqTabs;
}(react_default.a.Component);

/* harmony default export */ var faq_tabs = (faq_tabs_FaqTabs);
// EXTERNAL MODULE: ./src/components/templates/NotLoggedIn.tsx
var NotLoggedIn = __webpack_require__("bs2q");

// EXTERNAL MODULE: ./src/constants/staticUrl.ts
var staticUrl = __webpack_require__("FRS9");

// EXTERNAL MODULE: ./public/data/data-faq.json
var data_faq = __webpack_require__("uPsk");

// CONCATENATED MODULE: ./src/pages/faq.tsx
var faq_jsx = react_default.a.createElement;








var faq_FaqList = function FaqList() {
  return faq_jsx(react_default.a.Fragment, null, faq_jsx("p", null, "\u3088\u304F\u3042\u308B\u8CEA\u554F\u3068\u56DE\u7B54\u3092Q&A\u5F62\u5F0F\u3067\u3054\u7528\u610F\u3044\u305F\u3057\u307E\u3057\u305F\u3002\u304A\u554F\u3044\u5408\u308F\u305B\u3092\u3055\u308C\u308B\u524D\u306B\u3053\u3061\u3089\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002"), faq_jsx(faq_tabs, {
    items: data_faq
  }), faq_jsx("blockquote", null, faq_jsx("h3", null, "\u89E3\u6C7A\u3057\u306A\u3044\u5834\u5408\u306F"), faq_jsx("p", null, "\u4E0B\u8A18\u30EA\u30F3\u30AF\u304B\u3089\u304A\u554F\u3044\u5408\u308F\u305B\u65B9\u6CD5\u3092\u3054\u78BA\u8A8D\u306E\u4E0A\u3001\u304A\u554F\u3044\u5408\u308F\u305B\u304F\u3060\u3055\u3044\u3002"), faq_jsx(BigButton, {
    title: "\u304A\u554F\u3044\u5408\u308F\u305B",
    link: staticUrl["b" /* CONTACT_URL */]
  })));
};

var faq_Faq = function Faq() {
  return faq_jsx(react_default.a.Fragment, null, faq_jsx(NotLoggedIn["a" /* NotLoggedIn */], null, faq_jsx(head_default.a, null, faq_jsx("title", null, "\u3088\u304F\u3042\u308B\u8CEA\u554F")), faq_jsx("div", {
    className: "page-title"
  }, faq_jsx("section", null, faq_jsx("h1", null, "\u3088\u304F\u3042\u308B\u8CEA\u554F"))), faq_jsx("section", {
    id: "faq"
  }, faq_jsx(faq_FaqList, null))));
};
/* harmony default export */ var faq = __webpack_exports__["default"] = (faq_Faq);

/***/ }),

/***/ "vuIU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _createClass; });
/* harmony import */ var _toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("o46R");

function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, Object(_toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}


/***/ }),

/***/ "yLiY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.setConfig = setConfig;
exports["default"] = void 0;
var runtimeConfig;

var _default = function _default() {
  return runtimeConfig;
};

exports["default"] = _default;

function setConfig(configValue) {
  runtimeConfig = configValue;
}

/***/ })

},[["/RWt",0,1,2,3]]]);